import { publicDataSelectors } from '_core/store/PublicData'
import { findInObject } from '_core/utils/findInObject'
import { makeActionCreator } from '_core/utils/actions'
import { DEFAULT_CURRENCY_ID } from 'config'

// === Action types ===

const CURRENCY_RESET = 'CURRENCY_RESET'
const CURRENCY_CHANGE = 'CURRENCY_CHANGE'
const CURRENCY_UPDATE = 'CURRENCY_UPDATE'

// === Default state ===

const defaultState = {
  current: null,
  list: null,
}

// === Selectors ===

const getCurrencyList = store => publicDataSelectors.getCurrency(store).list

const getInitialCurrencyId = store => {
  return DEFAULT_CURRENCY_ID
}

const getCurrentCurrencyId = store =>
  publicDataSelectors.getCurrency(store).current

const getCurrencyInfoById = (store, currencyId) => {
  const list = getCurrencyList(store)
  return list != null ? findInObject(list, 'id', currencyId) : null
}

// === Actions ===

const changeCurrency = makeActionCreator(CURRENCY_CHANGE, 'id')

const updateCurrency = makeActionCreator(CURRENCY_UPDATE, 'data')

const resetCurrency = makeActionCreator(CURRENCY_RESET)

// === Exports ===

export const currencyDefaultState = defaultState

export const currencyActionTypes = {
  CURRENCY_RESET,
  CURRENCY_CHANGE,
  CURRENCY_UPDATE,
}

export const currencySelectors = {
  getCurrencyList,
  getInitialCurrencyId,
  getCurrentCurrencyId,
  getCurrencyInfoById,
}

export const currencyActions = {
  changeCurrency,
  updateCurrency,
  resetCurrency,
}
